import { RiArrowDropLeftLine, RiArrowDropRightLine } from 'react-icons/ri';
import { Button, Col, Row, TabPane } from 'reactstrap';
import { useAuthOnboarding } from '@src/utility/hooks/useAuthOnboarding';
import { FaDotCircle } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { useLoadingGlobal } from '@src/utility/hooks/useLoadingGlobal';
import apiOnboarding from '@src/services/api-onboarding';
import { toastError } from '@src/utility/Toast';
import WebCam from '../components/WebCam';
import PreviewsWebCam from '../components/PreviewsWebCam';

interface SendDocumentProps {
  handleChangeTabe: (tab: string) => void;
  activeTab: string;
  request?: Record<string, unknown>;
  title: string;
  description: string;
  actualTab: string;
  nextTab: string;
  frontOrBack: 'FRONT' | 'BACK';
}

const SendDocument: React.FC<SendDocumentProps> = ({
  handleChangeTabe,
  activeTab,
  request,
  title,
  description,
  actualTab,
  nextTab,
  frontOrBack,
}) => {
  const [base64, setBase64] = useState<string | null>(null);
  const { verifyLogin } = useAuthOnboarding();
  const { showLoader, hideLoader } = useLoadingGlobal();

  const handleScreenshot = (base64: string | null) => {
    setBase64(base64);
  };

  const handleTakeOffAgain = () => {
    setBase64((s) => null);
  };

  const handleSendFrontDocument = async () => {
    try {
      await verifyLogin();
      showLoader();
      if (request) {
        await apiOnboarding.post('api/operator/send-document', {
          idOperator: request.idOperator,
          typeDocument: `${request.typeDocument}_${frontOrBack}`,
          fileBase64: base64,
        });

        setBase64(null);
        handleChangeTabe(nextTab);
      }
      hideLoader();
    } catch (error) {
      hideLoader();
      toastError({
        title: 'Ops, algo deu errado!',
        description: 'Erro ao enviar a foto.',
      });
    }
  };

  const handleBackTab = () => {
    handleChangeTabe('3');
    setBase64(null);
  };

  useEffect(() => {
    setBase64(base64);
  }, [activeTab, base64]);

  return (
    <TabPane tabId={actualTab}>
      {activeTab === actualTab && base64 === null ? (
        <WebCam
          title={title}
          description={description}
          handleScreenshot={handleScreenshot}
          type={title}
        />
      ) : (
        <PreviewsWebCam base64={base64} takeOffAgain={handleTakeOffAgain} />
      )}
      <Row>
        <Col className="d-flex justify-content-between">
          <Button size="sm" onClick={() => handleBackTab()} color="secondary">
            <RiArrowDropLeftLine size={25} /> Anterior
          </Button>
          <Button
            size="sm"
            onClick={() => handleSendFrontDocument()}
            color="success"
            style={{ cursor: base64 ? 'pointer' : 'not-allowed' }}
            disabled={!base64}
          >
            Próximo <RiArrowDropRightLine size={25} />
          </Button>
        </Col>
      </Row>
    </TabPane>
  );
};

export default SendDocument;
